import { StrapiField, StrapiFieldType } from "~/types";

export const STATIC_FIELDS: StrapiField[] = [
  {
    __component: "shared.field",
    type: StrapiFieldType.input,
    title: "Email",
    uid: "email",
  },
  {
    __component: "shared.field",
    type: StrapiFieldType.input,
    title: "Phone number",
    uid: "phone",
  },
  {
    __component: "shared.field",
    type: StrapiFieldType.input,
    title: "Additional information",
    uid: "additionalInfo",
  },
];
